import { render, staticRenderFns } from "./jackpot-section.vue?vue&type=template&id=6c7fbfca&scoped=true&"
import script from "./jackpot-section.vue?vue&type=script&lang=js&"
export * from "./jackpot-section.vue?vue&type=script&lang=js&"
import style0 from "./jackpot-section.vue?vue&type=style&index=0&id=6c7fbfca&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7fbfca",
  null
  
)

export default component.exports